import { UserRewardStateLabel } from '@/components/RewardDetailExtremlyComplexComponets'
import styles from '@/styles/Rewards.module.scss'
import Link from 'next/link'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  link: string
  title: string
  query?: number | string
  course?: string
  state?: Api.UserStatus
  img: string
  startAt: string
  endAt: string
  presentType: Api.ConvertedPresentTypeId
  isApplicationForm?: 0 | 1 | number
  checkCondition: boolean
  withBorder?: boolean
}

/**
 * 特典一覧のコンポーネント
 * */
export const RewardList = memo(
  ({
    link,
    title,
    query,
    state,
    img,
    startAt,
    endAt,
    presentType,
    isApplicationForm,
    checkCondition,
    withBorder = true,
  }: Props) => {
    const { t } = useTranslation()
    const date = new Date()
    const period = date >= new Date(startAt) && date <= new Date(endAt)

    return (
      <Link
        href={{
          pathname: `${link}`,
          query: { query: query },
        }}
        legacyBehavior={true}
      >
        <a className={`c-list border-gray-200 flex items-center py-4 ${withBorder ? 'border-b' : ''}`}>
          <div className={`c-thumbnail_min-wrap ${period ? (checkCondition ? styles.c_batting : '') : ''}`}>
            <span className="c-thumbnail_min block">
              <img src={img} alt="" />
            </span>
          </div>
          <div className="c-thumbnail_min-list ml-2">
            <p className="text-sm font-bold">{title}</p>
            <div className="mt-1 flex items-center">
              <p className={`text-xs ${period ? 'text-color01' : 'text-color02'}`}>
                {period ? (
                  <>
                    <UserRewardStateLabel
                      presentType={presentType}
                      isApplicationForm={isApplicationForm}
                      userRewardState={state}
                      multiple={false}
                    />
                  </>
                ) : (
                  <>
                    {date < new Date(startAt) ? t('prize.before', '特典の獲得期間前です') : ''}
                    {date > new Date(endAt) ? t('prize.ended', '特典の獲得期間が終了しました') : ''}
                  </>
                )}
              </p>
            </div>
          </div>
        </a>
      </Link>
    )
  },
)
